export { default } from './ProductHero.js'
export type { ProductHeroProps } from './types.js'
